// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
// Helpers
import classNames from 'classnames';

/**
 *    TagHtml React presentational component.
 */
export class TagHtml extends PureComponent<*, *> {
  /**
   *    Props implementation.
   */
  static propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    bold: PropTypes.bool,
    classTagHtmlBold: PropTypes.string,
    classTagHtmlUnderline: PropTypes.string,
    classTagHtmlItalic: PropTypes.string,
    italic: PropTypes.bool,
    underline: PropTypes.bool,
    tag: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    attrs: PropTypes.object,
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  };

  /**
   *    Default Props implementation.
   */
  static defaultProps: Object = {
    bold: false,
    italic: false,
    underline: false,
    tag: 'span'
  };

  /**
   * Create css classes string based on props options.
   * @returns {classes} It returns a string containing the classes.
   */
  getStyleName(): string[] {
    let applyedStyle = [];
    let styles = {
      bold: 'classTagHtmlBold',
      underline: 'classTagHtmlUnderline',
      italic: 'classTagHtmlItalic'
    };
    for (let value in this.props) {
      if (this.props[value] && styles[value]) {
        applyedStyle.push(this.props[styles[value]]);
      }
    }
    return classNames(applyedStyle, this.props.className);
  }

  /**
   * React's replacement for using innerHTML in the browser DOM
   * See React's documentation https://facebook.github.io/react/docs/dom-elements.html
   * @param {html} html to be returned
   * @returns {html} It returns html
   *
   * @memberOf PrintHtml
   */
  createMarkup(html: string): Object {
    return { __html: html };
  }

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> | null {
    const TagElem = this.props.tag;
    const style = this.getStyleName();
    return (
      <TagElem
        className={classNames(style, this.props.extendStyle)}
        {...this.props.attrs}
        dangerouslySetInnerHTML={this.createMarkup(this.props.content)}
      />
    );
  }
}

export default TagHtml;



// WEBPACK FOOTER //
// ./src/Common/TagHtml/index.js